import type { OAuthProvider } from 'osep-auth-service-client-v1';
import atlassianLogo from '../../images/atlassian.png';
import gitLabLogo from '../../images/gitlab.png';

export type ProviderInfo = {
  label: string;
  logo: string;
};

export const PROVIDERS: Record<OAuthProvider, ProviderInfo> = {
  gitlab: { label: 'GitLab', logo: gitLabLogo },
  atlassian: { label: 'Atlassian', logo: atlassianLogo },
};
